import * as Yup from 'yup'

export const validationSchema = (questions: any) => {
    const validations: any = {}

    if (!questions) {
        return Yup.object().shape({})
    }

    questions.map((question: any) => {
        if (question.meta.required) {
            switch (question.meta.type) {
                case 'text':
                    validations[question.ID] = Yup.string().when("step", {
                        is: (value: string) => value >= question.step,
                        then: Yup.string().required()
                    })
                    break;
                case 'email':
                    validations[question.ID] = Yup.string().when("step", {
                        is: (value: string) => value && value >= question.step,
                        then: Yup.string().email().required()
                    })
                    break;
                case 'checkbox':
                    validations[question.ID] = Yup.object().nullable().when("step", {
                        is: (value: string) => { return value >= question.step },
                        then: Yup.object().nullable().test({
                            test: (arr: any, test: any) => {
                                if (test && test.originalValue.length > 0) {
                                    return true
                                }
                                return false
                            }
                        }),
                    })
                    break;

                case 'radio':
                    validations[question.ID] = Yup.string().nullable().when("step", {
                        is: (value: string) => value && value >= question.step,
                        then: Yup.string().nullable().required()
                    })
                    break;
                default:
                    break;
            }
        }

        return true
    })

    return Yup.object().shape(validations)
}